import React, { FC } from 'react';
import styled from 'styled-components';

import { SecondaryButton } from 'components/SecondaryButton';

import { OnboardingSubtitle, OnboardingTitle } from './StyledComponents';

type Props = {
  onPositive: () => void;
  onNegative: () => void;
};

const WelcomeStep: FC<Props> = ({ onNegative, onPositive }) => {
  return (
    <Container>
      <header>
        <OnboardingTitle title="Welcome to Shido" />
        <OnboardingSubtitle subtitle="Do you already have a Shido account?" />
      </header>
      <Actions>
        <SecondaryButton onClick={onPositive}>YES</SecondaryButton>
        <SecondaryButton onClick={onNegative}>NO</SecondaryButton>
      </Actions>
    </Container>
  );
};

const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 75px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    justify-content: space-between;
  }
`;

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  align-items: center;

  ${({ theme }) => theme.breakpoints.down('md')} {
    align-items: stretch;
    gap: 40px;
  }
`;

export default WelcomeStep;
